module.exports = __webpack_public_path__ + "static/media/bg-d.dde1c308.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-d.mp4
// module id = 18
// module chunks = 0